/**
 * Returns a random integer. Both min and max are included.
 */
export function randomIntBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
//# sourceMappingURL=randomIntBetween.js.map